import morphism, { StrictSchema } from 'morphism'

import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ServerNewPassengerInterface from '../../interfaces/server/NewPassenger'

import serverPassengerSchema from '../../schemas/server/passenger'

export default (passengers: ClientPassengerInterface[]) =>
  passengers.map((passenger: ClientPassengerInterface) =>
    morphism<
      StrictSchema<ServerNewPassengerInterface, ClientPassengerInterface>
    >(serverPassengerSchema, passenger)
  )
